import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Table, Icon, Modal } from "antd";

import { useAxios } from "../../../../shared/hooks/useAxios";
import { useNotification } from "../../../../shared/hooks/useNotification";

const confirm = Modal.confirm;

const TableDesktopGrupos = ({
    className,
    ativo,
    grupos,
    pagination,
    loading,
    handleChange,
    handleExpand,
    handleRowClickGrupo,
    handleRowClickHabilidade,
    abrirDrawerGerirHabilidade,
    atualizarListagemDeGrupos,
    atualizarListagemDeHabilidades
}) => {
    const { loading: saveLoading, notAuthorized, fetchData } = useAxios();
    const notify = useNotification();

    const divStyle = { display: "flex", alignItems: "center", gap: "10px", justifyContent: "flex-end" };

    const alterarEstadoGrupo = grupoId => {
        confirm({
            title: ativo ? "Pretende inativar este grupo?" : "Pretende ativar este grupo?",
            okText: "Confirmar",
            okType: "Cancelar",
            onOk: async () => {
                const { data, error } = await fetchData({
                    method: "put",
                    url: `/api/habilidades/grupo/${grupoId}/estado`
                });

                if (!error) {
                    notify.success("Sucesso", ativo ? "Grupo inativado!" : "Grupo ativado!");
                    atualizarListagemDeGrupos();
                } else {
                    notify.error("Erro", ativo ? "Não foi possível inativar o grupo!" : "Não foi possível ativar o grupo!");
                }
            }
        });
    };

    const excluirGrupo = grupoId => {
        confirm({
            title: "Pretende excluir este grupo?",
            okText: "Confirmar",
            okType: "Cancelar",
            onOk: async () => {
                const { data, error } = await fetchData({
                    method: "delete",
                    url: `/api/habilidades/excluir-grupo/${grupoId}`
                });

                if (!error) {
                    notify.success("Sucesso", "Grupo excluido");
                    atualizarListagemDeGrupos();
                } else {
                    notify.error("Erro", "Não foi possível excluir o grupo");
                }
            }
        });
    };

    const alterarEstadoHabilidade = (grupoId, habilidadeId) => {
        confirm({
            title: ativo ? "Pretende inativar esta habilidade?" : "Pretende ativar esta habilidade?",
            okText: "Confirmar",
            okType: "Cancelar",
            onOk: async () => {
                const { data, error } = await fetchData({
                    method: "put",
                    url: `/api/habilidades/habilidade/${habilidadeId}/estado`
                });

                if (!error) {
                    notify.success("Sucesso", ativo ? "Habilidade inativada!" : "Habilidade ativada!");
                    atualizarListagemDeHabilidades(grupoId);
                } else {
                    notify.error("Erro", ativo ? "Não foi possível inativar a habilidade!" : "Não foi possível ativar a habilidade!");
                }
            }
        });
    };

    const excluirHabilidade = (grupoId, habilidadeId) => {
        confirm({
            title: "Pretende excluir esta habilidade?",
            okText: "Confirmar",
            okType: "Cancelar",
            onOk: async () => {
                const { data, error } = await fetchData({
                    method: "delete",
                    url: `/api/habilidades/excluir-habilidade/${habilidadeId}`
                });

                if (!error) {
                    notify.success("Sucesso", "Habilidade excluida");
                    atualizarListagemDeHabilidades(grupoId);
                } else {
                    notify.error("Erro", "Não foi possível excluir a habilidade");
                }
            }
        });
    };

    const montarMenuGrupo = grupo => {
        if (ativo)
            return (
                <div style={divStyle}>
                    <Link
                        to="#"
                        className="botao-icon-adicionar"
                        title="Adicionar Disciplina"
                        onClick={event => {
                            event.stopPropagation();
                            abrirDrawerGerirHabilidade(grupo.id, 0);
                        }}
                    >
                        <Icon type="plus" />
                    </Link>
                    <Link
                        to="#"
                        className="botao-icon-inativar"
                        title="Inativar"
                        onClick={event => {
                            event.stopPropagation();
                            alterarEstadoGrupo(grupo.id);
                        }}
                    >
                        <Icon type="close" />
                    </Link>
                </div>
            );

        return (
            <div style={divStyle}>
                <Link
                    to="#"
                    className="botao-icon-ativar"
                    title="Ativar"
                    onClick={event => {
                        event.stopPropagation();
                        alterarEstadoGrupo(grupo.id);
                    }}
                >
                    <Icon type="check" />
                </Link>
                <Link
                    to="#"
                    className="botao-icon-excluir"
                    title="Excluir"
                    onClick={event => {
                        event.stopPropagation();
                        excluirGrupo(grupo.id);
                    }}
                >
                    <Icon type="delete" />
                </Link>
            </div>
        );
    };

    const montarMenuHabilidade = habilidade => {
        if (habilidade?.ativo)
            return (
                <div style={divStyle}>
                    <Link
                        to="#"
                        className="botao-icon-inativar"
                        title="Inativar"
                        onClick={event => {
                            event.stopPropagation();
                            alterarEstadoHabilidade(habilidade.grupoId, habilidade.id);
                        }}
                    >
                        <Icon type="close" />
                    </Link>
                </div>
            );

        return (
            <div style={divStyle}>
                <Link
                    to="#"
                    className="botao-icon-ativar"
                    title="Ativar"
                    onClick={event => {
                        event.stopPropagation();
                        alterarEstadoHabilidade(habilidade.grupoId, habilidade.id);
                    }}
                >
                    <Icon type="check" />
                </Link>
                <Link
                    to="#"
                    className="botao-icon-excluir"
                    title="Excluir"
                    onClick={event => {
                        event.stopPropagation();
                        excluirHabilidade(habilidade.grupoId, habilidade.id);
                    }}
                >
                    <Icon type="delete" />
                </Link>
            </div>
        );
    };

    const columns = [
        {
            title: "Grupo",
            dataIndex: "nome"
        },
        {
            title: "",
            dataIndex: "opcoes",
            className: "td-50",
            render: (text, record) => montarMenuGrupo(record)
        }
    ];

    const columnsSubgrupos = [
        {
            title: "Subgrupo",
            dataIndex: "nome"
        }
    ];

    const columnsHabilidades = [
        {
            title: "Habilidade",
            dataIndex: "nome",
            render: (text, record) => {
                const label = record.codigo ? `${record.codigo} - ${record.nome}` : record.nome;

                return !record.ativo ? <div style={{ opacity: "0.3" }}>{label}</div> : label;
            }
        },
        {
            title: "",
            dataIndex: "opcoes",
            width: "100px",
            render: (text, record) => montarMenuHabilidade(record)
        }
    ];

    return (
        <Table
            id="cursos-disciplinas"
            className={className}
            loading={{
                spinning: false,
                indicator: (
                    <div className="loading-data-table">
                        <div className="loading" />
                    </div>
                )
            }}
            columns={columns}
            dataSource={grupos}
            pagination={pagination}
            rowClassName="clickeble-row"
            rowKey={(record, index) => index}
            onRow={(record, index) => {
                return {
                    onClick: () => handleRowClickGrupo(record.id)
                };
            }}
            locale={{ emptyText: "Não existem dados!" }}
            onChange={handleChange}
            onExpand={handleExpand}
            expandedRowRender={(record, index) => (
                <>
                    {record.subgrupos?.length > 0 && (
                        <Table
                            //id="disciplinas"
                            columns={columnsSubgrupos}
                            dataSource={record.subgrupos}
                            pagination={false}
                            rowClassName="clickeble-row"
                            rowKey={(subrecord, index) => index}
                            expandedRowRender={(record, index) => (
                                <Table
                                    columns={columnsHabilidades}
                                    dataSource={record.habilidades}
                                    pagination={false}
                                    scroll={{ y: 300 }}
                                    rowClassName="clickeble-row"
                                    rowKey={(subrecord, index) => index}
                                    onRow={(subrecord, index) => {
                                        return {
                                            onClick: () => handleRowClickHabilidade(record.id, subrecord.id)
                                        };
                                    }}
                                    locale={{ emptyText: "Não existem registos!" }}
                                />
                            )}
                            locale={{ emptyText: "Não existem registos!" }}
                        />
                    )}
                    {record.habilidades?.length > 0 && (
                        <Table
                            //id="disciplinas"
                            columns={columnsHabilidades}
                            dataSource={record.habilidades}
                            pagination={false}
                            scroll={{ y: 300 }}
                            rowClassName="clickeble-row"
                            rowKey={(subrecord, index) => index}
                            onRow={(subrecord, index) => {
                                return {
                                    onClick: () => handleRowClickHabilidade(record.id, subrecord.id)
                                };
                            }}
                            locale={{ emptyText: "Não existem registos!" }}
                        />
                    )}
                </>
            )}
        />
    );
};

export default TableDesktopGrupos;
